import React, { useState, useEffect } from 'react';
import styled from 'astroturf/react';

import { trackClick } from 'js/utils/trackClick';
import routes from 'sitewide-js/core_pre_webpack/routes';
import ModalBase from 'js/components/modals/Modal';
import { Button } from 'js/design_system/Button';
import { imageUrl } from 'js/utils/image_url';
import { Colors } from 'js/design_system/Color';
import CloseIcon from 'js/design_system/icons/close.svg';
import { cancelTasteOfMentionsTest } from '../api';
import { TextButton } from 'js/design_system/TextButton';

const Modal = styled(ModalBase)`
  max-width: 624px;
  padding: 0;

  @media (max-width: 567px) {
    width: 100%;
    margin: 0;
    border-radius: 0;
  }
`;

const Container = styled.div`
  display: flex;
  padding: 40px;
  flex-direction: column;
  align-items: center;
  gap: var(--spacing-sm-24, 24px);
  border-radius: 6px;
  border: 2px solid var(--secondary-500, #4960d1);
  background: var(--White, #fff);
  width: 100%;
`;

const Logo = styled.img`
  width: 82px;
  height: 82px;
  margin-bottom: var(--spacing-xs-8, 8px);
`;

const Title = styled.h1`
  font-size: 32px;
  font-style: normal;
  font-weight: 400;
  line-height: 32px;
  color: #000;
  margin: 0;
  padding: 0;
`;

const Text = styled.div`
  font-size: 16px;
  font-style: normal;
  font-weight: 400;
  line-height: 20px;
  text-align: center;
`;

const CloseButton = styled(TextButton)`
  position: absolute;
  right: 12px;
  top: 12px;
  height: 48px;
  width: 48px;
  padding: 0;
`;

type Props = {
  onClose: () => void;
};

const TasteOfMentionsUpsellModal = ({ onClose }: Props) => {
  const [disabled, setDisabled] = useState(false);

  useEffect(() => {
    async function cancelTest() {
      await cancelTasteOfMentionsTest();
    }
    cancelTest();
  }, []);

  const onClick = () => {
    trackClick({
      source: 'TasteOfMentionsUpsellModal',
      extra: {},
    });
    setDisabled(true);
    onClose();
    window.location.href = routes.mentions_path();
  };

  return (
    <Modal onClose={onClick}>
      <Container>
        <Logo
          src={imageUrl('line_illustrations/transparent_v2/atomic_model.svg')}
          alt="Atom illustration"
        />
        <Title>Thank you for your interest</Title>
        <Text>
          We're currently testing our Premium trial experience. You now have
          <strong> access to all of your Mentions</strong> as part of your
          trial.
        </Text>
        <Button disabled={disabled} onClick={onClick}>
          Close
        </Button>
      </Container>
      <CloseButton aria-label="Close" onClick={onClick}>
        <CloseIcon color={Colors.GrayDark} />
      </CloseButton>
    </Modal>
  );
};

export default TasteOfMentionsUpsellModal;
